export default __webpack_public_path__ + "graph-volume-blue.png?5efd0aa2dc91bce9171b3225126bf9c0";